export const types = {
  SET_PAY_PERIOD: 'guaranteedHoursReport/SET_PAY_PERIOD',
};

export const setPayPeriod = (payPeriod) => {
  return {
    type: types.SET_PAY_PERIOD,
    payPeriod,
  };
};

export const setPayPeriodThunk = (payPeriod) => {
  return async (dispatch, getState, { history }) => {
    dispatch(setPayPeriod(payPeriod));
  };
};
